import React, { useState, useEffect } from 'react';
import '../listarcliente.css';
import axios from 'axios';
import { Input, Button, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

function ListarCliente() {
    const [clientes, setClientes] = useState([]);
    const [searchNome, setSearchNome] = useState('');
    const [searchContador, setSearchContador] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        
        try {
            axios({
                method:"post",
                url:`${localStorage.getItem('url')}/web/todosclientes/`,
                headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
                data:{id:"sds"}
            }).then(dat=>{ if(dat.status!==200){
                throw Error('Dados de acesso invalidos');  
                    }
                return dat
             } ).then( df=>{
              setClientes(df.data);
              console.log(clientes);
               
              }
           
               ).catch(e=>{
                    
            })
           
        } catch (error) {
            console.error(error.message);
        }
    };

    const handleSearchNome = value => {
        setSearchNome(value);
    };

    const handleSearchContador = value => {
        setSearchContador(value);
    };

    const filteredClientes = clientes.filter(cliente => {
        return (
            cliente.nome.toLowerCase().includes(searchNome.toLowerCase()) &&
            cliente.numero_do_contador.toLowerCase().includes(searchContador.toLowerCase())
        );
    });

    const columns = [
        {
            title: 'ID',
            dataIndex: 'idcliente',
            key: 'idcliente'
        },
        {
            title: 'Nome',
            dataIndex: 'nome',
            key: 'nome'
        },
        {
            title: 'Nuit',
            dataIndex: 'nuit',
            key: 'nuit'
        },
        {
            title: 'BI',
            dataIndex: 'bi',
            key: 'bi'
        },
        {
            title: 'Morada',
            dataIndex: 'morada',
            key: 'morada'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email'
        },
        {
            title: 'Telefone',
            dataIndex: 'contato',
            key: 'contato'
        },
        {
            title: 'Contador',
            dataIndex: 'numero_do_contador',
            key: 'numero_do_contador'
        }
    ];

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filteredClientes);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Clientes');
        XLSX.writeFile(wb, 'clientes.xlsx');
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        doc.text("Clientes", 10, 10);
        doc.autoTable({ html: '#table-to-xls' });
        doc.save('clientes.pdf');
    };

    return (
        <div className='ClienteL'>
            <div className='filters'>
                <Input
                    placeholder="Pesquisar por nome"
                    prefix={<SearchOutlined />}
                    onChange={e => handleSearchNome(e.target.value)}
                    value={searchNome}
                    className="mr-4"
                />
                <Input
                    placeholder="Pesquisar por contador"
                    prefix={<SearchOutlined />}
                    onChange={e => handleSearchContador(e.target.value)}
                    value={searchContador}
                />
                <Button onClick={exportToExcel}>Exportar para Excel</Button>
            </div>
            <div className='procurar'>
                <Table columns={columns} dataSource={filteredClientes} pagination={false} />
            </div>
        </div>
    );
}

export default ListarCliente;
